import ScubaMetrics from './ScubaMetrics';
import UtapiMetrics from './UtapiMetrics';
import getConfig from './Config';

export default class MetricsAPI {
    constructor() {
        this.implementation;
    }

    async initialize() {
        const config = (await getConfig()).configData;

        if (config.metricsBackend === 'utapi') {
            this.implementation = new UtapiMetrics();
        } else if (config.metricsBackend === 'scuba') {
            this.implementation = new ScubaMetrics();
        } else {
            throw new Error('Invalid metrics backend');
        }
    }

    async getBucketMetrics(bucket, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getBucketMetrics(bucket, startDate, endDate);
    }

    async getAccountMetrics(account, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getAccountMetrics(account, startDate, endDate);
    }

    async getSystemMetrics(startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getSystemMetrics(startDate, endDate);
    }

    async getMultipleBucketsMetrics(buckets, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getMultipleBucketsMetrics(buckets, startDate, endDate);
    }

    async getMultipleAccountsMetrics(accounts, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getMultipleAccountsMetrics(accounts, startDate, endDate);
    }

    async getBucketMetricsHistory(bucket, interval, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getBucketMetricsHistory(bucket, interval, startDate, endDate);
    }

    async getAccountMetricsHistory(account, interval, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getAccountMetricsHistory(account, interval, startDate, endDate);
    }

    async getSystemMetricsHistory(interval, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getSystemMetricsHistory(interval, startDate, endDate);
    }

    async getMultipleBucketsHistory(interval, startDate, endDate) {
        if (!this.implementation) {
            await this.initialize();
        }
        return this.implementation.getMultipleBucketsHistory(interval, startDate, endDate);
    }
}



/** WEBPACK FOOTER **
 ** ./src/utils/MetricsAPI.js
 **/